function setMeta(attr, key, value) {
  if (!value) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setCanonical(url) {
  if (!url) return;
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", url);
}

export function syncDocumentHead({ title, description, canonical, ogImage }) {
  if (title) document.title = title;

  setMeta("name", "description", description);
  setMeta("property", "og:title", title);
  setMeta("property", "og:description", description);
  setMeta("property", "og:url", canonical);
  setMeta("property", "og:type", "website");
  setMeta("property", "og:image", ogImage);
  setMeta("name", "twitter:card", "summary_large_image");
  setMeta("name", "twitter:title", title);
  setMeta("name", "twitter:description", description);
  setMeta("name", "twitter:image", ogImage);
  setCanonical(canonical);
}

export function readHeadFromDocument(doc) {
  if (!doc) return null;

  return {
    title: doc.querySelector("title")?.textContent?.trim() || "",
    description:
      doc.querySelector('meta[name="description"]')?.getAttribute("content") || "",
    canonical:
      doc.querySelector('link[rel="canonical"]')?.getAttribute("href") || "",
    ogImage:
      doc.querySelector('meta[property="og:image"]')?.getAttribute("content") || "",
  };
}
